import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAchievementAnalysisSmile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 23.5001C18.799 23.5001 23.5 18.7991 23.5 13.0001C23.5 7.20104 18.799 2.5 13 2.5C7.20101 2.5 2.5 7.20104 2.5 13.0001C2.5 18.7991 7.20101 23.5001 13 23.5001Z",
			fill: "#DEFFCE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9988 18.0106C11.4762 18.0106 10.0256 17.3536 9.0195 16.209C8.69917 15.8448 8.7349 15.2906 9.09911 14.9703C9.46332 14.6506 10.0175 14.6863 10.3378 15.0499C11.011 15.8159 11.9808 16.2554 12.9988 16.2554C14.0169 16.2554 14.9866 15.8159 15.6599 15.0499C15.9796 14.6857 16.5344 14.6499 16.8986 14.9703C17.2628 15.29 17.2985 15.8448 16.9782 16.209C15.9714 17.3536 14.5215 18.0106 12.9988 18.0106Z",
			fill: "#7FE166"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.93412 12.397C10.7051 12.397 11.3301 11.772 11.3301 11.001C11.3301 10.2299 10.7051 9.60492 9.93412 9.60492C9.16311 9.60492 8.53809 10.2299 8.53809 11.001C8.53809 11.772 9.16311 12.397 9.93412 12.397Z",
			fill: "#7FE166"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.066 12.397C16.837 12.397 17.462 11.772 17.462 11.001C17.462 10.2299 16.837 9.60492 16.066 9.60492C15.2949 9.60492 14.6699 10.2299 14.6699 11.001C14.6699 11.772 15.2949 12.397 16.066 12.397Z",
			fill: "#7FE166"
		})
	]
});
export default SvgIconAchievementAnalysisSmile;
